import date from '~/utils/date';

export function convertToInputFormat(mmYyyy?: string): string {
  if (!mmYyyy) return '';
  const [month, year] = mmYyyy.split('-');
  return `${year}-${month}`;
}

export function convertToStorageFormat(yyyyMm?: string): string {
  if (!yyyyMm) return '';
  const [year, month] = yyyyMm.split('-');
  return `${month}-${year}`;
}

export function formatCompetencyMonth(dateString?: string): string {
  if (!dateString) return '-';

  if (dateString.includes('-') && dateString.length === 7) {
    return dateString.replace('-', '/');
  }

  return date.utc(dateString).format('MM/YYYY');
}
